var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"loading-label"},[_vm._v("Loading...")]),_c('br'),_c('span',{staticClass:"my-loader"})])}]

export { render, staticRenderFns }